export interface Size {
    width: number;
    height: number;
}

export interface Point {
    x: number;
    y: number;
}

export class Crop {
    size: Size;

    point: Point;

    outputSize: Size;

    length: number;

    constructor();

    constructor(crop: Crop);

    constructor(crop?: Crop) {
        if (crop) {
            this.size = { width: crop.size.width, height: crop.size.height };
            this.outputSize = {
                width: crop.outputSize.width,
                height: crop.outputSize.height,
            };
            this.point = { x: crop.point.x, y: crop.point.y };
            this.length = crop.length;
        } else {
            this.size = { width: 0, height: 0 };
            this.outputSize = { width: 0, height: 0 };
            this.point = { x: 0, y: 0 };
            this.length = 0;
        }
    }

    compareArea = (rh: Crop) => (
            rh.size.width === this.size.width &&
            rh.size.height === this.size.height &&
            rh.outputSize.width === this.outputSize.width &&
            rh.outputSize.height === this.outputSize.height &&
            rh.point.x === this.point.x &&
            rh.point.y === this.point.y
        );
}
